import { inject } from 'inversify';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { urlMaker } from '@core/utils';
import { bind } from '@infra/container';

import { DeclarationMapper, IDeclaration } from '@modules/declarations';

export type IGetBoxDeclarationsRepoResponse = IRepoResponse<200, { data: IDeclaration[]; total: number }> | IRepoResponse<400 | 500, string>;

export type IGetBoxDeclarationsRepo = IRepo<[any], IGetBoxDeclarationsRepoResponse>;

export const GetBoxDeclarationsRepoType = Symbol.for('GetBoxDeclarationsRepo');

@bind(GetBoxDeclarationsRepoType)
export class GetBoxDeclarationsRepo implements IGetBoxDeclarationsRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(query: any) {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/api/admin/flights/box_declarations', query) });

      if (result.status === 200) {
        const data: IDeclaration[] = result.data.data.map((item) => DeclarationMapper.toDomain(item));
        const total: number = result.data.total;

        return {
          status: 200 as 200,
          response: { data, total },
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
